/**
 * GestureNode.tsx
 * Gestureカードのビューコンポーネント
 * 選んだモーション名を表示し、設定はダイアログで行う
 */
import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import type { GestureNode } from '../../types';
import { getGestureLabel } from '../../config/gestureMotions';
import { getNodeDisplayLabel, useFlowDisplayLanguage } from '../../displayLanguage';
import { CardShell } from '../CardShell';

export const GestureNodeView = memo(function GestureNodeView({ data }: NodeProps<GestureNode>) {
  const displayLanguage = useFlowDisplayLanguage();

  return (
    <CardShell
      kind="gesture"
      accent="violet"
      title={getNodeDisplayLabel('gesture', displayLanguage)}
      summary={getGestureLabel(data.motionId) ?? ''}
    >
      <Handle type="target" position={Position.Left} className="!bg-violet-500" />
      <Handle type="source" position={Position.Right} className="!bg-violet-500" />
    </CardShell>
  );
});
